var map = {
	"./Chinese.json": "bd10",
	"./Dutch.json": "1844",
	"./English.json": "bbfa",
	"./French.json": "653e",
	"./German.json": "4cab",
	"./Italian.json": "adc9",
	"./Japanese.json": "9ced",
	"./Korean.json": "2119",
	"./Portuguese.json": "293e",
	"./Russian.json": "c598",
	"./Spanish.json": "28e6",
	"./Swedish.json": "bf25",
	"./untranslate.json": "042c",
	"./wizard/Arabic.json": "b540",
	"./wizard/Chinese.json": "52eb",
	"./wizard/Czech.json": "8bd4",
	"./wizard/Danish.json": "61fb",
	"./wizard/Dutch.json": "8532",
	"./wizard/English.json": "0185",
	"./wizard/Finnish.json": "878a",
	"./wizard/French.json": "7b06",
	"./wizard/German.json": "c850",
	"./wizard/Greek.json": "8d5b",
	"./wizard/Hungarian.json": "e8c4",
	"./wizard/Italian.json": "5f20",
	"./wizard/Japanese.json": "24ea",
	"./wizard/Korean.json": "5941",
	"./wizard/Norwegian.json": "e820",
	"./wizard/Polish.json": "07e1",
	"./wizard/Portuguese.json": "6f3b",
	"./wizard/Romanian.json": "eb57",
	"./wizard/Russian.json": "7e04",
	"./wizard/Slovak.json": "0955",
	"./wizard/Slovenian.json": "324a",
	"./wizard/Spanish.json": "4bf6",
	"./wizard/Swedish.json": "f77b",
	"./wizard/Traditional-Chinese.json": "1a2c",
	"./wizard/Turkish.json": "73e2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "231a";